import { fetchAPI } from '@quickbit/backoffice-core-frontend';

interface MerchantLogo {
  merchantLogo: {
    logoUrl: string;
    enabled: boolean;
  };
}

export const postMerchantLogo = async (logoData: {
  imagedata?: string;
  filename?: string;
  enabled: boolean;
}) => {
  const data = await fetchAPI(`v1/merchant/branding/logo`, {
    method: 'POST',
    body: {
      ...logoData,
    },
  });
  return data;
};

export const getMerchantLogo = async (): Promise<MerchantLogo> => {
  return await fetchAPI(`v1/merchant/branding/logo`, {
    method: 'GET',
  });
};
